<template>
  <div class="mobile-page">
    <div class="wrap">
      <el-container>
        <el-row :gutter="12">
          <el-col :span="17" class="wrap-top">
            <el-col :span="3">
              <router-link to="/">
                <div class="return-arrow">
                  <i class="el-icon-arrow-left" />
                </div>
              </router-link>
            </el-col>
            <el-col :span="9">
              <el-form class="margin-top">
                <el-form-item>
                  <el-select v-model="cityCode" placeholder="选择城市" clearable="clearable" autocomplete="off">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.text" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form class="margin-top">
                <el-form-item>
                  <el-select v-model="type" placeholder="选择服务类型" clearable="clearable" autocomplete="off">
                    <el-option v-for="item in typeOptions" :key="item.index" :label="item.text" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-col>
          </el-col>
          <el-col :span="7" class="margin-top">
            <div class="button-div">
              <div @click="toggleMapMode" class="map-div">
                <img src="../assets/map.png" class="map-img">
                <span class="map-text">地图模式</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </div>
    <el-dialog
      title="通知及公告"
      :visible.sync="isNoticeDialogVisible"
      @close="isNoticeDialogVisible = false"
      width="90%"
    >
      <div class="dialog-content">
        <h4 class="notice-title" v-html="currentFacilityNotice.title || ''" />
        <div v-html="currentFacilityNotice.content || ''" />
      </div>
      <div class="divider" />
      <span slot="footer">
        <el-button class="confirm-button" @click="isNoticeDialogVisible = false" size="small">
          确定
        </el-button>
      </span>
    </el-dialog>
    <div v-loading="loading" class="loading-div" style="overflow-y: auto;">
      <div v-if="init" v-infinite-scroll="load"
           :infinte-scroll-disabled="disabled"
      >
        <div class="facilities" v-for="facility in facilityList" :key="facility.id">
          <div class="facility">
            <el-row>
              <el-col :span="19">
                <div class="facility-title">
                  <div class="title-wrapper">
                    <h4 class="facility-name">{{ facility.facilityName }}</h4>
                    <i v-if="facility.title && facility.content" class="el-icon-document facility-speaker"
                       @click="showFacilityNotice(facility)"
                    />
                  </div>
                  <div class="icon-div-grey">
                    <i class="el-icon-location-outline" />
                    <p class="facility-address">{{ facility.facilityAddress }}</p>
                  </div>
                </div>
                <div class="time-div">
                  <i class="el-icon-time" />
                  <p class="time-text">{{ facility.amTime }}</p>
                  <p class="time-text-right">{{ facility.pmTime }}</p>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="facility-business-status">
                  <div v-if="facility.isBusinessHours" class="open-status">
                    <p class="open-status-text">
                      营业中
                    </p>
                  </div>
                  <div v-if="!facility.isBusinessHours" class="closed-status">
                    <p class="closed-status-text">
                      休息中
                    </p>
                  </div>
                  <p class="distance-text">{{ facility.dinstanceFmt }}</p>
                </div>
              </el-col>
            </el-row>

            <div class="facility-service">
              <div class="service" v-if="facility.serviceType && facility.serviceType.includes(1005001)">
                <div class="icon-div">
                  <img src="../assets/icon_per.png" class="icon-img">
                  <span>个人详版查询</span>
                </div>
              </div>
              <div class="service" v-if="facility.serviceType && facility.serviceType.includes(1005002)">
                <div class="icon-div">
                  <img src="../assets/icon_smart.png" class="icon-img">
                  <span>个人简版查询</span>
                </div>
              </div>
              <div class="service" v-if="facility.serviceType && facility.serviceType.includes(1005003)">
                <div class="icon-div">
                  <img src="../assets/icon_per_hk.png" class="icon-img">
                  <span>个人港澳台回乡证查询</span>
                </div>
              </div>
              <div class="service" v-if="facility.serviceType && facility.serviceType.includes(1005004)">
                <div class="icon-div">
                  <img src="../assets/icon_ent.png" class="icon-img">
                  <span>企业电子营业执照授权查询</span>
                </div>
              </div>
              <div class="service" v-if="facility.serviceType && facility.serviceType.includes(1005005)">
                <div class="icon-div">
                  <img src="../assets/per_statement.png" class="icon-img">
                  <span>人工柜台服务</span>
                </div>
              </div>
            </div>
          </div>
          <div class="divider" />
          <div class="facility-button">
            <span slot="reference" class="function-icon-div" @click="call(facility.phone)">
                <img src="../assets/icon_phone.png" class="function-icon-img">
                电话
            </span>
            <span @click="navigateFunction(facility)" class="function-icon-div">
              <img src="../assets/icon_navigate.png" class="function-icon-img">
              导航
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import locationUtil from "@/utils/LocationUtil";
import wxUtil from "@/utils/WxUtil";
import txMapUtil from "@/utils/TxMapUtil";

export default {
  data() {
    return {
      timer: null,
      // 初始状态:0, 定位成功:1 定位失败:2 不支持定位:3
      positionState: 0,
      rowData: [],
      chunkSize: 10,
      chunkIndex: 0,
      init: false,
      loading: true,
      countdowns: {},
      cityCode: '',
      location: '',
      defaultCityName: '兰州市',
      defaultCityCode: '620100',
      defaultLocation: '103.848068,36.052349',
      type: null,
      facilityList: [],
      isNoticeDialogVisible: false,
      isChosen: 'N',
      msg: '',
      currentFacilityNotice: {
        title: '',
        content: ''
      },
      cityOptions: [
        {value: '620100', text: '兰州市'},
        {value: '620200', text: '嘉峪关市'},
        {value: '620300', text: '金昌市'},
        {value: '620400', text: '白银市'},
        {value: '620500', text: '天水市'},
        {value: '620600', text: '武威市'},
        {value: '620700', text: '张掖市'},
        {value: '620800', text: '平凉市'},
        {value: '620900', text: '酒泉市'},
        {value: '621000', text: '庆阳市'},
        {value: '621100', text: '定西市'},
        {value: '621200', text: '陇南市'},
        {value: '622900', text: '临夏回族自治州'},
        {value: '623000', text: '甘南藏族自治州'}
      ],
      typeOptions: [
        {index: 0, value: 1005001, text: '个人详版查询'},
        {index: 1, value: 1005002, text: '个人简版查询'},
        {index: 2, value: 1005003, text: '个人港澳台回乡证查询'},
        {index: 3, value: 1005004, text: '企业电子营业执照授权查询'},
        {index: 4, value: 1005005, text: '人工柜台服务'}
      ]
    }
  },
  computed: {
    noMore() {
      return this.chunkIndex >= this.rowData.length;
    },
    disabled() {
      return this.loading || this.noMore
    },
    getCenterByCityCode() {
      const item = this.cityOptions.find(item => {
        if (this.cityCode && item.value === this.cityCode) {
          return item;
        }
      });
      return item ? item.text : this.defaultCityName;
    },
  },
  watch: {
    cityCode(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isChosen = 'Y'
        this.cityCode = newValue
        this.getListData()
      }
    },
    type(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.isChosen = 'Y'
        this.type = newValue
        this.getListData()
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$store.getters.cityCode) {
        this.cityCode = this.$store.getters.cityCode
        this.location = this.defaultLocation;
      } else {
        locationUtil.getLocation().then(result => {
          this.location = result.location;
          this.positionState = result.positionState;
          this.msg = result.msg;
          this.getListData();
        });
      }
    }, 300)
  },
  methods: {
    load() {
      if (this.rowData.length > 0) {
        this.facilityList = this.facilityList.concat(this.rowData.slice(this.chunkIndex, this.chunkIndex + this.chunkSize));
        this.chunkIndex = this.chunkIndex + this.chunkSize;
      }
    },
    setDefaultLocation() {
      this.location = this.defaultLocation;
      this.cityCode = this.defaultCityCode;
    },
    showFacilityNotice(facility) {
      this.currentFacilityNotice.title = facility.title
      this.currentFacilityNotice.content = facility.content
      this.isNoticeDialogVisible = true
    },
    call(number) {
      if (number) {
        window.location.href = `tel:${number}`
      }
    },
    navigateFunction(facility) {
      if (window.miniprogram) {
        wxUtil.openLocation(facility.longitude.split(',')[1], facility.longitude.split(',')[0], facility.facilityName, facility.facilityAddress, '', '');
      } else {
        // this.$router.push({
        //   name: 'Map',
        //   params: {
        //     facilityList: [facility],
        //     location: this.location,
        //     center: {lng: facility.longitude.split(',')[0], lat: facility.longitude.split(',')[1]}
        //   }
        // })
        txMapUtil.navigate(facility);
      }
    },
    toggleMapMode() {
      this.$router.push(
        {
          name: 'txMap',
          params: {
            facilityList: this.rowData,
            location: this.location,
            currentCityCode: this.cityCode,
            currentBusinessType: this.type,
            center: this.getCenterByCityCode,
          }
        }
      )
    },
    getListData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      } else {
        this.timer = setTimeout(() => {
          this.init = false;
          this.loading = true
          if (this.positionState !== 1) {
            this.positionState = 0;
            this.$message({
              message: this.msg + ',自动切换到' + this.defaultCityName,
              type: 'info',
              duration: 2000
            });
          }
          axios.post(this.$config.baseUrl + '/appointment-web/facilityController/getFacilityList', {
            cityCode: this.cityCode,
            type: this.type,
            location: this.location,
            isChosen: this.isChosen
          }, {headers: {'Content-Type': 'application/json'}})
            .then(response => {
              this.timer = null;
              this.loading = false
              let _data = response.data.facilityList;
              if (_data && _data.length === 0 && this.positionState === 1) {
                this.$message({
                  message: '距离您10公里范围内无法找到对应网点信息,自动切换到' + this.defaultCityName,
                  type: 'info',
                  duration: 2000
                });
                this.setDefaultLocation();
              }
              if (response.data && _data.length > 0) {
                this.rowData = _data;
              } else {
                this.rowData = [];
                this.facilityList = [];
              }
              this.init = true;
              this.resetFacilityParam();
            })
            .catch(error => {
              this.loading = false
              console.log('请求错误:', error)
            })
        }, 300);
      }
    },
    resetFacilityParam() {
      this.facilityList = [];
      this.chunkIndex = 0;
    }

  }
}
</script>

<style scoped>
.mobile-page {
  background-color: #f1f1f1;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.wrap {
  background-color: white;
}

.margin-top {
  margin-top: 10px;
}

.facilities {
  background-color: white;
  margin: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.facility {
  padding: 15px 15px 5px 15px;
}

.facility-address {
  margin: 0;
  color: #999;
  font-size: 13px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.facility-service {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}

.service {
  padding: 5px 0;
  margin-right: 10px;
  font-size: 14px;
}

.facility-button {
  font-size: 14px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
}

.divider {
  height: 1px;
  background-color: #ddd;
  margin: 0 15px;
}

.icon-div-grey {
  color: #a3a3a3;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.time-div {
  padding-top: 10px;
  color: #a3a3a3;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 5px;
}

.time-text {
  margin: 0;
  font-size: 14px;
  padding-left: 2px;
}

.time-text-right {
  margin: 0;
  font-size: 14px;
  padding-left: 10px;
}

.facility-business-status {
  position: relative;
  text-align: center;
}

.open-status {
  background-color: #2696e8;
  margin-bottom: 5px;
}

.closed-status {
  background-color: #e1e1e1;
  margin-bottom: 5px;
}

.open-status-text {
  padding: 2px;
  margin: 0;
  font-size: 17px;
  color: white;
}

.closed-status-text {
  padding: 2px 0 2px 0;
  margin: 0;
  font-size: 17px;
  color: #888888;
}

.distance-text {
  margin: 0;
  color: #b7b7b7;
  font-size: 12px;
}

.notice-title {
  text-align: center;
}

::v-deep .el-dialog__body {
  padding: 0 20px 10px 20px !important;
}

::v-deep .el-dialog__header {
  margin: 0 20px;
  padding: 20px 0 10px 0;
}

.dialog-content {
  height: 480px;
}

::v-deep .el-dialog__footer {
  text-align: center !important;
}

.confirm-button {
  color: #b22d32;
}

.title-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 9px;
}

.facility-name {
  margin: 0;
  font-weight: 548;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.facility-speaker {
  font-size: 16px;
  color: #b22d32;
  cursor: pointer;
  margin-left: 5px;
  align-self: center;
}

.icon-img {
  max-height: 21px;
  max-width: 21px;
}

.icon-div {
  color: #2696e8;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.button-div {
  width: 95%;
  text-align: center;
  display: flex;
}

.map-div {
  background: linear-gradient(to bottom, #6bc2fc, #2695e8);
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px;
  border-radius: 5px;
}

.map-img {
  max-height: 25px;
  max-width: 25px;
}

.map-text {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.function-icon-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.function-icon-img {
  max-height: 25px;
  max-width: 25px;
}

.loading-div {
  height: 100vh;
}

.return-arrow {
  cursor: pointer;
  margin: 15px 0 22px 5px;
  font-size: 20px;
  color: #888888;
  z-index: 99;
}
</style>
